import { createTheme, createVariant, globalTheme } from '@cld/component-theme';
import { PaperProps } from './PaperProps';

const { palette, radius, shadow, spacing } = globalTheme;

export const theme = createTheme(
  {
    background: palette.surface,
    radiusVariant: {
      sm: {
        radius: radius.unstable_new.sm,
        padding: spacing.sm,
      },
      md: {
        radius: radius.unstable_new.md,
        padding: spacing.sm,
      },
      lg: {
        radius: radius.unstable_new.lg,
        padding: spacing.sm,
      },
      xl: {
        radius: radius.unstable_new.xl,
        padding: spacing.lg,
      },
    },
    depthVariant: {
      sm: {
        shadow: shadow.sm,
      },
      md: {
        shadow: shadow.md,
      },
      lg: {
        shadow: shadow.lg,
      },
    },
  },
  'paper'
);

export const radiusVariant = createVariant((props: PaperProps) => theme.radiusVariant[props.radius || 'md']);
export const depthVariant = createVariant((props: PaperProps) => theme.depthVariant[props.depth || 'md']);
